import styled from '@emotion/styled'

export const Container = styled('div')`
  display: flex;
  margin-left: 'auto';
`

export const FilterIcon = styled('div')`
  font-size: 24px;
  color: #fff;
`

export const Notification = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  font-size: 12px;
  background: #ef3e39;
  border-radius: 50px;
  color: #fff;
  position: absolute;
  z-index: 99999;
`
